import { render, staticRenderFns } from "./ReportPersonaCard.vue?vue&type=template&id=3cf07da6&"
import script from "./ReportPersonaCard.vue?vue&type=script&lang=js&"
export * from "./ReportPersonaCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports